/**
 * @generated SignedSource<<9aa2b66adce0f68ffb02dfbe8ce69c6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportConfigQueuesToolbar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configurationTaskMetrics",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

node.hash = "7e10120a679428a080ec81451194766e";

module.exports = node;
